import type { SiteConfig } from "@site-factory/config";
import { resolveTheme } from "@site-factory/theme";
import { themeSelection } from "./theme";

export const siteConfig: SiteConfig = {
  id: "template-site",
  name: "Template Site",
  domain: "template.example.com",
  theme: resolveTheme(themeSelection),
  navigation: {
    links: [
      { label: "Components", href: "/styleguide" },
      { label: "Section Gallery", href: "/gallery" },
      { label: "Theme", href: "/theme" },
    ],
    primaryCta: {
      label: "View Sections",
      href: "/gallery",
    },
  },
  layout: {
    homepageSections: ["hero", "features", "services", "about", "testimonials", "faq", "contact"],
  },
};
